import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';

export function withIconComponent(iconfont: IconDefinition) {
    return {
        component: FontAwesomeIcon,
        props: {
            icon: [iconfont.prefix, iconfont.iconName]
        }
    };
}
